import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
    Container,
    Typography,
    Paper,
    Box,
    LinearProgress,
    CircularProgress,
    Alert,
} from "@mui/material";
import axios from "axios";
import { getAuthToken } from "../utils/authToken";

function AdminDeepLUsagePage() {
    const [usage, setUsage] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const tokenFromState = useSelector((state) => state.auth.token);
    const token = getAuthToken(tokenFromState);

    useEffect(() => {
        if (!token) {
            setUsage(null);
            setError("Authentication token missing. Please sign in again.");
            setLoading(false);
            return;
        }
        setLoading(true);
        setError("");
        axios
            .get("/api/deepl/admin/usage", {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then((res) => {
                setUsage(res.data);
            })
            .catch((err) => {
                setError(
                    err.response?.data?.msg ||
                    "Failed to fetch MT usage. Are you admin?"
                );
            })
            .finally(() => setLoading(false));
    }, [token]);

    return (
        <Container maxWidth="sm" sx={{ mt: 6 }}>
            <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
                <Typography variant="h4" gutterBottom>
                    MT Account Usage (Admin)
                </Typography>

                {loading ? (
                    <Box display="flex" justifyContent="center" py={4}>
                        <CircularProgress />
                    </Box>
                ) : error ? (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        {error}
                    </Alert>
                ) : (
                    <>
                        <Typography variant="h6" sx={{ mb: 1 }}>
                            Characters Used
                        </Typography>
                        <Box mb={2}>
                            <Typography>
                                {usage.character_count.toLocaleString()} /{" "}
                                {usage.character_limit.toLocaleString()} characters
                            </Typography>
                            <LinearProgress
                                variant="determinate"
                                value={
                                    usage.character_limit
                                        ? (usage.character_count / usage.character_limit) * 100
                                        : 0
                                }
                                sx={{ height: 10, borderRadius: 5, mt: 1 }}
                            />
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                                {(
                                    (usage.character_count / usage.character_limit) *
                                    100
                                ).toFixed(2)}
                                % used
                            </Typography>
                        </Box>

                        <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
                            Documents Used
                        </Typography>
                        <Box>
                            <Typography>
                                {usage.document_count.toLocaleString()} /{" "}
                                {usage.document_limit.toLocaleString()} documents
                            </Typography>
                            <LinearProgress
                                variant="determinate"
                                value={
                                    usage.document_limit
                                        ? (usage.document_count / usage.document_limit) * 100
                                        : 0
                                }
                                sx={{ height: 10, borderRadius: 5, mt: 1 }}
                                color="secondary"
                            />
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                                {(
                                    (usage.document_count / usage.document_limit) *
                                    100
                                ).toFixed(2)}
                                % used
                            </Typography>
                        </Box>

                        <Box mt={4}>
                            <Typography variant="body2" color="text.secondary">
                                Last refreshed: {new Date().toLocaleString()}
                            </Typography>
                        </Box>
                    </>
                )}
            </Paper>
        </Container>
    );
}

export default AdminDeepLUsagePage;
